import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Grid, Tab, Tabs } from '@mui/material';

import * as theme from '../../theme';

import { ReactComponent as ClearIcon } from '../../assets/icons/clear-icon-gray.svg';

const TimetableTabs = (props) => {
    const { key, tabvalue, onRemove, isReadOnly } = props;

    return (
        <Container key={key}>
            <TimetableTabsContainer
                {...props}
                TabIndicatorProps={{
                    style: {
                        display: 'none',
                    },
                }}
            >
                {/* TODO: clcking the remove icon triggers the onChange as well so the tab being removed end up getting selected*/}
                {/*<TimetableTab {...props} value={tabvalue} icon={<ClearIcon onClick={onRemove} />} iconPosition="end" />*/}
                <TimetableTab {...props} value={tabvalue} iconPosition="end" isReadOnly={isReadOnly} />
                {!isReadOnly && (
                    <StyledButton onClick={onRemove}>
                        <ClearIcon />
                    </StyledButton>
                )}
            </TimetableTabsContainer>
        </Container>
    );
};

export default TimetableTabs;

const Container = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    white-space: nowrap;
    max-height: 55px;
`;

const TimetableTabsContainer = styled(Tabs)`
    && {
        margin-top: 10px;

        .MuiTab-root {
            min-width: 100px;
            min-height: 48px;
            background-color: ${theme.colors.unSelected};
            color: ${theme.colors.blue2};
            font-weight: 500;
            opacity: 1;
            display: inline-block;
        }

        .Mui-selected {
            background-color: #fff;
        }
    }
`;

const TimetableTab = styled(Tab)`
    && {
        padding: ${(props) => (props.isReadOnly ? '8px 12px' : '8px 30px 8px 12px')};
        background-color: #fff;
        border-top: 2px solid ${theme.colors.blue2};

        .MuiTab-wrapper {
            display: inline-flex;
            flex-direction: row-reverse;
        }
    }
`;

const StyledButton = styled.button`
    background: transparent;
    border: none;
    margin-left: -30px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 10px;

    & > svg {
        margin: 0;

        &:hover {
            cursor: pointer;
            opacity: 0.7;
        }
    }
`;
